import assetsBase from '@exodus/assets-base'
import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

const assets = assetsBase.default || assetsBase

export const APP_URL = 'https://fiat.a.exodus.io' // proxy request to paypal

export const ENABLED_ASSETS = {
  __proto__: null,
  eth_ethereum: assets.ethereum?.name,
  btc_bitcoin: assets.bitcoin?.name,
  bch_bitcoin_cash: assets.bcash?.name,
  ltc_litecoin: assets.litecoin?.name,
  pyusd_ethereum: assets.pyusd_ethereum_871d3761?.name,
  pyusd_solana: assets['2b1k_solana_f3924eb0']?.name,
}

export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  paypal: 'paypal',
}

export const PAYMENT_METHODS = new Map([
  [
    PAYMENT_METHOD_NAMES.paypal,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.paypal,
      type: PAYMENT_METHOD_TYPES.paypal,
      countries: [{ id: 'US', enabled: true }],
      currencies: [{ id: 'USD', enabled: true }],
    }),
  ],
])

export const ORDER_STATUSES = {
  __proto__: null,
  completed: 'COMPLETED',
  failed: 'FAILED',
  initiated: 'INITIATED',
  pending: 'PENDING',
}

export const EXODUS_ORDER_STATUSES = {
  __proto__: null,
  complete: [ORDER_STATUSES.completed],
  failed: [ORDER_STATUSES.failed],
  'in-progress': [ORDER_STATUSES.pending],
}
